<script setup lang="ts">
import type { UiTone, UiSize } from '~/utils/ui'
const props = withDefaults(
  defineProps<{
    // Vue preserves aria-* names instead of camelizing them.
    // eslint-disable-next-line vue/prop-name-casing
    'aria-label': string
    variant?: 'solid' | 'soft' | 'outline' | 'ghost' | 'chrome'
    tone?: UiTone
    size?: UiSize
    disabled?: boolean
    loading?: boolean
    type?: 'button' | 'submit' | 'reset'
  }>(),
  {
    disabled: undefined,
    loading: undefined,
    variant: 'ghost',
    tone: 'neutral',
    size: 'md',
    type: 'button',
  },
)
// Runtime Vue normalizes the declared HTML prop name to camelCase.
const accessibleName = computed(() => (props as unknown as { ariaLabel: string }).ariaLabel)
const action = ref<{ focus: () => void; element?: HTMLButtonElement }>()
defineExpose({
  focus: () => action.value?.focus(),
  get element() {
    return action.value?.element
  },
})
</script>
<template>
  <UiButton
    ref="action"
    class="ui-icon-button"
    :aria-label="accessibleName"
    :variant="variant"
    :tone="tone"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :type="type"
    ><slot
  /></UiButton>
</template>
